import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const Container = styled.div<{ isEmptyRange?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${({ isEmptyRange }) => (isEmptyRange ? '8px' : '33.5px 24px')};
  width: 100%;
  background: ${colors.white};
  border-radius: 4px;
  position: relative;
`

export const SectionTitleMain = styled.span`
  margin-bottom: 8px;
  color: ${colors.mainText};
  font-size: 18px;
  line-height: 150%;
  font-weight: 600;
`

export const SectionTitle = styled.span`
  margin-bottom: 8px;
  color: ${colors.mainText};
  font-size: 14px;
  line-height: 150%;
  font-weight: 400;
`

export const EstimatedReach = styled.div`
  margin-top: 8px;
  display: grid;
  gap: 8px;

  @media ${device.mobileMin} {
    grid-template-columns: 1fr 1fr;
  }
`

export const EstimatedReachLabel = styled.span`
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: ${colors.greyTextWhiteBg};
`

export const EstimatedReachValue = styled(EstimatedReachLabel)`
  margin: 0 40px 0 8px;
  color: ${colors.mainText};
`

export const EstimationWrapper = styled.div<{ isMinEqualsMax?: boolean }>`
  @media ${device.mobileMax} {
    top: 72px;
    width: calc(100% - 35px);
    padding-right: 24px;

    position: ${({ isMinEqualsMax }) =>
      isMinEqualsMax ? 'static' : 'absolute'};
    left: 59px;

    ${SectionTitle} {
      display: block;
      margin-bottom: 16px;
    }

    ${EstimatedReach} {
      flex-direction: column;
    }

    ${EstimatedReachLabel} {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      &:first-child {
        margin-bottom: 8px;
      }
    }

    ${EstimatedReachValue} {
      margin: 0;
    }
  }
`

export const SliderContainer = styled.div`
  margin: 13px 0 35.5px 0;
`

export const EstimatedReachExplanation = styled.div<{ isEmptyRange?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: ${({ isEmptyRange }) => (isEmptyRange ? '0px' : '40px')};
`

export const EstimatedReachIcon = styled.img`
  display: flex;
  align-self: flex-start;
  margin-top: 4px;
  margin-right: 8px;
  width: 16px;
`

export const EstimatedReachExplanationText = styled(SectionTitle)<{
  isEmptyRange?: boolean
}>`
  ${({ isEmptyRange }) => {
    if (isEmptyRange) {
      return `
        @keyframes fadingTextColor {
          0% {
            color: ${colors.messegesYellow1};
          }
          50% {
            color: ${colors.messegesYellow1};
          }
          75% {
            color: ${colors.messegesYellow1};
          }
          100% {
            color: ${colors.mainText};
          }
        }

        animation-name: fadingTextColor;
        animation-duration: 6s;
      `
    }
    return ``
  }}
  margin-bottom: 0;
  color: ${colors.mainText};
`

export const EditGenresAndLanguagesButton = styled.div<{
  isEmptyRange?: boolean
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 9.5px;
  margin-left: 24px;
  width: fit-content;
  font-size: 14px;
  color: ${({ isEmptyRange }) =>
    isEmptyRange ? colors.messegesYellow1 : colors.mainText};
  border-bottom: 1px dashed
    ${({ isEmptyRange }) =>
      isEmptyRange ? colors.messegesYellow1 : colors.mainText};
  cursor: pointer;
`

export const AlertContainer = styled.div<{
  isEmptyRange?: boolean
  isMinEqualsMax?: boolean
}>`
  padding: ${({ isEmptyRange }) =>
    isEmptyRange ? '24px 16px 25.5px 16px' : '0'};
  border-radius: 4px;
  
    @media ${device.mobileMax} {
      margin-top: 24px;
      margin-bottom: 34px;

      ${({ isEmptyRange, isMinEqualsMax }) =>
        !isEmptyRange && !isMinEqualsMax
          ? `
        ${EstimatedReachExplanation} {
          margin-top: 0;
        }
      `
          : ``}
      ${({ isMinEqualsMax, isEmptyRange }) => {
        if (isEmptyRange) {
          return `
            margin-top: 0;

            ${EstimatedReachExplanation} {
              margin-top: 0;
            }
          `
        }
        if (isMinEqualsMax) {
          return `
            margin-top: 40px;
    
            ${EstimatedReachExplanation} {
              margin-top: 0;
            }
          `
        }
        return ``
      }}
      ${EditGenresAndLanguagesButton} {
        margin-left: 0;
      }
      ${EstimatedReachIcon} {
        display: none;
      }
  }
`
export const Notice = styled.span<{ isEmptyRange?: boolean }>`
  display: none;
  @media ${device.mobileMax} {
    display: block;
    color: ${({ isEmptyRange }) =>
      isEmptyRange ? colors.messegesYellow1 : colors.messegesGreen1};
    font-size: 14px;
    font-weight: 600;
  }
`

export const CampaignBudget = styled.p`
  margin: 0 0 38.5px 0 !important;
`

export const CampaignBudgetLabel = styled.span`
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  color: ${colors.mainText};
`

export const CampaignBudgetAmount = styled(CampaignBudgetLabel)`
  font-weight: 600;
`

export const MatchingBlock = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 99px;
  border: 1px solid ${colors.greyStroke};
  border-radius: 4px;
`

export const MatchingBlockHeader = styled.p`
  display: flex;
  justify-content: space-between;
  margin: 0;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: ${colors.mainText};
`

export const MatchingBlockValue = styled.div``

export const MatchingBlockValueMain = styled.span`
  font-size: 20px;
  line-height: 150%;
  font-weight: 600;
  color: ${colors.mainText};
`

export const MatchingBlockValueSecond = styled(MatchingBlockValueMain)`
  margin-left: 4px;
  font-size: 14px;
  font-weight: 400;
`

export const CenteredBlock = styled.div`
  margin: 0 auto;
`

export const HintModal = styled.div<{ left?: boolean }>`
  position: absolute;
  padding: 26px 24px;
  color: ${colors.mainText};
  background: ${colors.white};
  font-size: 14px;
  line-height: 1;
  z-index: 100;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  width: 320px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  transform: translate(50%, -50%);
  left: ${({ left }) => (left ? '-80' : '340')}px;
  top: 50%;
`
